import { render } from "./ProductManagement.vue?vue&type=template&id=873f5158&scoped=true"
import script from "./ProductManagement.vue?vue&type=script&lang=js"
export * from "./ProductManagement.vue?vue&type=script&lang=js"

import "./ProductManagement.vue?vue&type=style&index=0&id=873f5158&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-873f5158"]])

export default __exports__